const TAB_TO_SPACES = "  ";
export function toLines(tokens) {
    const lines = [[]];
    const tokenStack = tokens.slice();
    let col = 1;
    while (tokenStack.length) {
        const token = tokenStack.shift();
        if (typeof token === "string") {
            const [value, ...tail] = token.split("\n");
            if (value) {
                let start = col;
                col += value.length;
                lines[lines.length - 1].push({
                    value,
                    range: [start, col],
                });
            }
            if (tail.length) {
                lines[lines.length - 1].push({
                    value: "\n",
                    range: [col, col + 1],
                });
                lines.push([]);
                col = 1;
                tokenStack.unshift(tail.join("\n"));
            }
        }
        else {
            const [value, color, rest = {}] = token;
            let start = col;
            col += value.length;
            lines[lines.length - 1].push({
                value,
                style: { color, ...rest },
                range: [start, col],
            });
        }
    }
    const totalLines = lines.length;
    return lines.map((tokens, i) => {
        var _a, _b, _c;
        return ({
            tokens,
            range: [i + 1, i + 1],
            lineNumber: i + 1,
            indentation: ((_c = (_b = (_a = tokens[0]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.replace(/\t/g, TAB_TO_SPACES).match(/^\s*/)) === null || _c === void 0 ? void 0 : _c[0].length) || 0,
            totalLines,
        });
    });
}
export function toLineGroups(lines, annotations) {
    let groups = lines;
    for (let i = annotations.length - 1; i >= 0; i--) {
        const annotation = annotations[i];
        groups = applyBlockAnnotation(groups, annotation);
    }
    return groups;
}
function applyBlockAnnotation(lines, annotation) {
    const { fromLineNumber, toLineNumber } = annotation;
    const range = [fromLineNumber, toLineNumber];
    let groups = splitGroups(lines, range[0]);
    groups = splitGroups(groups, range[1] + 1);
    let before = [];
    let inside = [];
    let after = [];
    groups.forEach((group) => {
        if (group.range[1] < range[0]) {
            before.push(group);
        }
        else if (group.range[0] > range[1]) {
            after.push(group);
        }
        else {
            inside.push(group);
        }
    });
    return [
        ...before,
        {
            annotation,
            lines: inside,
            range: [inside[0].range[0], inside[inside.length - 1].range[1]],
        },
        ...after,
    ];
}
function splitGroups(groups, lineNumber) {
    const index = groups.findIndex((group) => {
        return (isGroup(group) &&
            group.range[0] < lineNumber &&
            lineNumber <= group.range[1]);
    });
    if (index === -1) {
        return groups;
    }
    const group = groups[index];
    const lines = splitGroups(group.lines, lineNumber);
    let before = [];
    let after = [];
    lines.forEach((lineOrGroup) => {
        if (lineOrGroup.range[1] < lineNumber) {
            before.push(lineOrGroup);
        }
        else {
            after.push(lineOrGroup);
        }
    });
    return [
        ...groups.slice(0, index),
        { ...group, lines: before, range: [group.range[0], lineNumber - 1] },
        { ...group, lines: after, range: [lineNumber, group.range[1]] },
        ...groups.slice(index + 1),
    ];
}
export function isGroup(item) {
    return item.annotation !== undefined;
}
